import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nftPge"
  }, [_c('div', {
    staticClass: "nftPge-preload",
    style: {
      background: `
      url(${require('@images/tapcoin/new/fortune/fortune-card-Bgblack.png')}),
      url(${require('@images/tapcoin/new/fortune/fortune-card-Bgblue.png')}),
      url(${require('@images/tapcoin/new/fortune/fortune-card-Bggreen.png')}),
      url(${require('@images/tapcoin/new/fortune/fortune-card-Bgorange.png')}),
      url(${require('@images/tapcoin/new/fortune/fortune-card-Bgpink.png')}),
      url(${require('@images/tapcoin/new/fortune/fortune-card-Bgred.png')}),
      url(${require('@images/tapcoin/new/fortune/fortune-card-Bgyellow.png')})
      `
    }
  }), _c('div', {
    staticClass: "nft-body"
  }, [_c('div', {
    staticClass: "nft-bg",
    style: {
      background: `url(${require('@images/tapcoin/new/niceLucky/nft-bg.jpg')}) center top/100% auto no-repeat`
    }
  }), _c('div', {
    staticClass: "nft-main"
  }, [_c('div', {
    staticClass: "nft-shard"
  }, [_c('div', {
    staticClass: "nft-shard__title",
    on: {
      "click": _vm.onQuest
    }
  }, [_vm._v(" NFT SHARDS "), _c('div', {
    staticClass: "icon-quest"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-quest"
    }
  })], 1)]), _c('div', {
    staticClass: "nft-ship"
  }, [_c('div', {
    staticClass: "nft-ship-img"
  }, [_c('img', {
    staticClass: "ship",
    attrs: {
      "src": require('@images/tapcoin/new/niceLucky/icon-ship.png'),
      "alt": ""
    }
  }), _c('img', {
    staticClass: "light",
    attrs: {
      "src": require('@images/tapcoin/new/niceLucky/light.png'),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "nft-tag"
  }, [_c('span', [_vm._v(_vm._s(_vm.NFTBalance))]), _vm._v("/10 ")])]), _c('div', {
    staticClass: "nft-btns"
  }, [!_vm.iscraftLoading ? _c('div', {
    staticClass: "btn-craft",
    class: _vm.NFTBalance < 10 && 'disable',
    on: {
      "click": function ($event) {
        _vm.NFTBalance >= 10 && _vm.onCraft();
      }
    }
  }, [_vm._v("Craft an NFT")]) : _c('div', {
    staticClass: "btn-craft"
  }, [_c('div', {
    staticClass: "circleLoading"
  })])])])]), _c('div', {
    staticClass: "nft-menu"
  }, [_vm._m(0), _c('div', {
    staticClass: "nft-menu-main"
  }, [_c('div', {
    staticClass: "nft-menu-list"
  }, _vm._l(_vm.NFTMenu, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "nft-menu-item",
      on: {
        "click": function ($event) {
          return _vm.onMenu(item);
        }
      }
    }, [_c('div', {
      staticClass: "nft-menu-item__icon"
    }, [_c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }), item.value == 'task' && _vm.$refs?.popNftTaskRef?.todayItem?.completed == false ? _c('div', {
      staticClass: "nft-menu-item-tag"
    }) : _vm._e()]), _c('div', {
      staticClass: "nft-menu-item__label"
    }, [_vm._v(_vm._s(item.label))]), item.value == 'task' ? [_vm.$refs?.popNftTaskRef?.dailyList && _vm.$refs?.popNftTaskRef?.todayItem?.completed ? _c('div', {
      staticClass: "nft-menu-item-time"
    }, [_c('div', {
      staticClass: "nft-menu-item-time-main"
    }, [_vm._v(_vm._s(_vm._f("formatHour")(_vm.$refs?.popNftTaskRef?.distance)))])]) : _vm._e()] : _vm._e()], 2);
  }), 0)])]), _c('div', {
    staticClass: "nft-info",
    style: {
      background: `url(${require('@images/tapcoin/new/nftInfo/nftInfo-me.jpg')}) center top/100% auto`
    }
  }, [_c('div', {
    staticClass: "nft-info-btn",
    on: {
      "click": () => _vm.$router.push('/nftInfo')
    }
  }, [_vm._v("NFT INFO")])]), _c('div', {
    staticClass: "nft-my"
  }, [_c('div', {
    staticClass: "nft-my__title"
  }, [_vm._v("My NFT")]), _vm.myNFTList && _vm.myNFTList.length > 0 ? _c('div', {
    staticClass: "nft-my-list"
  }, _vm._l(_vm.myNFTList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "nft-my-item",
      on: {
        "click": function ($event) {
          return _vm.onNftDetail(item);
        }
      }
    }, [item.is_use ? _c('div', {
      staticClass: "nft-my-item-tag"
    }, [_c('img', {
      attrs: {
        "src": require('@images/tapcoin/new/fortune/forturn-tag.png'),
        "alt": ""
      }
    })]) : _vm._e(), _c('div', {
      staticClass: "nft-my-item__img"
    }, [_c('img', {
      attrs: {
        "src": item.image_url,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "nft-my-item__label"
    }, [_vm._v(_vm._s(item.name))])]);
  }), 0) : _vm._e()])])]), _c('div', {
    staticClass: "mMenu"
  }, [_c('m-menu')], 1), _c('pop-nft-shards', {
    attrs: {
      "list": _vm.NFTPricesList,
      "show": _vm.popNFTShardsShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popNFTShardsShow = $event;
      }
    }
  }), _c('pop-nft-task', {
    ref: "popNftTaskRef",
    attrs: {
      "show": _vm.popNFTTaskShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popNFTTaskShow = $event;
      }
    }
  }), _c('pop-reward', {
    attrs: {
      "show": _vm.popRewardShow,
      "data": _vm.rewardData
    },
    on: {
      "update:show": function ($event) {
        _vm.popRewardShow = $event;
      },
      "finish": _vm.popRewardFinish
    }
  }), _c('pop-nft-detail', {
    attrs: {
      "show": _vm.popNftDetailShow,
      "detail": _vm.nftDetail
    },
    on: {
      "update:show": function ($event) {
        _vm.popNftDetailShow = $event;
      }
    }
  }), _c('pop-dialog', {
    attrs: {
      "show": _vm.popNFTInfoShow,
      "width": "70%"
    },
    on: {
      "update:show": function ($event) {
        _vm.popNFTInfoShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "popNFTInfo"
  }, [_c('div', {
    staticClass: "popNFTInfo__title"
  }, [_vm._v("MetaCats")]), _c('div', {
    staticClass: "popNFTInfo__con"
  }, [_c('p', [_vm._v("1.10 NFT Shards can be combined into one MetaCats NFT")]), _c('p', [_vm._v("2. MetaCats NFT will soon be freely traded on exchanges")])])])]), _c('pop-dialog', {
    attrs: {
      "show": _vm.popObtainNextTimeShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popObtainNextTimeShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "popInsufficientBalance"
  }, [_c('div', {
    staticClass: "popInsufficientBalance__title"
  }, [_vm._v(" A brand new batch of even rarer MetaCat NFTs is coming soon!"), _c('br'), _c('br'), _vm._v(" Please continue collecting more shards to greatly increase your priority and the probability of obtaining them next time! ")])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nft-menu__title"
  }, [_c('span', [_vm._v("Get NFT Shards")])]);
}];
export { render, staticRenderFns };